import { forwardRef, RefObject } from 'react';
import { Survey as SurveyJS } from 'survey-react-ui';
import { useSurveyJS } from '~/layouts/surveyJS/useSurveyJs';

interface NoteTemplateRevisionProps {
  noteId: string;
  noteTemplateRevisionData: unknown | undefined;
  noteTemplateRevisionSchema: unknown | undefined; // should be changed to Record<string, unknown> in a followup
  isReadOnly?: boolean;
}

const NoteTemplateRevisionForm = forwardRef(
  (
    {
      noteId,
      noteTemplateRevisionData,
      noteTemplateRevisionSchema,
      isReadOnly,
    }: NoteTemplateRevisionProps,
    ref: RefObject<SurveyJS>,
  ) => {
    const { model } = useSurveyJS({
      isReadOnly,
      templateSchema: noteTemplateRevisionSchema,
      jsonData: {
        ...(typeof noteTemplateRevisionData === 'object' &&
        noteTemplateRevisionData !== null
          ? noteTemplateRevisionData
          : {}),
        noteTemplateRevisionSchema,
      },
    });

    return (
      <SurveyJS id={`note-template-form-${noteId}`} model={model} ref={ref} />
    );
  },
);

NoteTemplateRevisionForm.displayName = 'NoteTemplateRevisionForm';
export default NoteTemplateRevisionForm;
